import {Injectable} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Message} from '@stomp/stompjs';
import {Store} from '@ngrx/store';
import * as fromRoot from '../store/app.reducers';
import {RxStompService} from './rx-stomp.service';

@Injectable()
export class ReportingWsUpdateService {
  private reportingMessages: Observable<Message>;
  private reportingSubscription: Subscription;

  constructor(private store: Store<fromRoot.AppState>, private stompService: RxStompService) {
  }

  /**
   * Subscribe to the reporting topic to receive updates.
   *
   * @param report to subscribe
   */
  subscribeReportingTopic(report: ReportDto): Observable<any> {

    this.reportingMessages = this.stompService
      .watch('/topic/finished-report/'
            + report.reportType + '/'
            + report.channel + '/'
            + report.from.getDate() + (report.from.getMonth() + 1) + report.from.getFullYear() + '/'
            + report.to.getDate() + (report.to.getMonth() + 1) + report.to.getFullYear());
    return this.reportingMessages;

  }

  /**
   * Unsubscribe from the current reporting topic.
   */
  unsubscribeReportingTopic(): void {
    if (this.reportingSubscription) {
      this.reportingSubscription.unsubscribe();
    }
  }
}
